import { render } from "./OrderDetailPage.vue?vue&type=template&id=23cb943b"
import script from "./OrderDetailPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailPage.vue?vue&type=script&lang=ts"
script.render = render

export default script